import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MysamplesComponent } from './mysamples.component';
import { RouterModule, Routes } from '@angular/router';
import { HeaderMysamplesComponent } from '../../components/mysamples/header-mysamples/header-mysamples.component';
import { TabsComponent } from '../../components/tabs/tabs.component';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonComponent } from '../../components/button/button.component';
import { SamplesCardComponent } from '../../components/mysamples/samples-card/samples-card.component';

const routes: Routes = [
  { path: '', component: MysamplesComponent }
];

@NgModule({
  declarations: [MysamplesComponent],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    HeaderMysamplesComponent,
    TabsComponent,
    TranslateModule,
    ButtonComponent,
    SamplesCardComponent
  ]
})
export class MysamplesModule { }
